import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const residencePeriodSchema = validator.object().shape({
  residencePeriod: validator.string().emptyToNull().label("在留期間").notRequired(),
  residencePeriodRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(7)
    .label("在留期間の在留申請CSVコード")
    .notRequired(),
  desiredResidencePeriod: validator.string().emptyToNull().label("希望する在留期間").notRequired(),
  desiredResidencePeriodRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .label("希望する在留期間の在留申請CSVコード")
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(10)
    .notRequired(),
});

export const masterDataCreateResidenceStatusSchema = validator.object().shape({
  residenceStatus: validator.string().emptyToNull().label("在留資格").required(),
  residenceStatusRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("在留資格の在留申請CSVコード")
    .notRequired(),
  residencePeriods: validator.array().of(residencePeriodSchema).label("residencePeriods").required(),
});

export const masterDataUpdateResidenceStatusSchema = validator.object().shape({
  residenceStatus: validator.string().emptyToNull().label("在留資格").required(),
  residenceStatusRenewVisaCsvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("在留資格の在留申請CSVコード")
    .notRequired(),
});
